<template>
  <usage-bar :usage="usage">
    <span class="usage-text">{{ usageLine }}</span>
  </usage-bar>
</template>

<script>
import UsageBar from "@/components/admin/bars/UsageBar.vue";

import { roundTo } from "@/utils/calc.js";

// @group Admin Page
// Show used percents
export default {
  name: "PercentageUsageBar",
  components: {
    UsageBar
  },
  props: {
    // In range 0-1
    usage: {
      type: Number,
      default: 0,
      validator: val => {
        return val >= 0 && val <= 1;
      }
    },
    // Number of decimal places
    accuracy: {
      type: Number,
      default: 1,
      validator: val => {
        return Number.isInteger(val) && val >= 0;
      }
    }
  },
  computed: {
    // @vuese
    // Usage text in percentage format
    usageLine() {
      return roundTo(this.usage * 100, this.accuracy) + "%";
    }
  }
};
</script>

<style scoped>
.usage-text {
  font-weight: bold;
}
</style>
